<style>
  .tch-info-modal .ivu-modal-wrap{
    z-index: 2000;
  }
</style>
<template>
<div>
  <Modal title="约陪练课" v-model="visible" width="600" :mask-closable="false">
    <Form ref="chineseLessonForm" class="form"
      :model="companionPracticingParam" :rules="chineseLessonRule"
      :label-width="80">
      <Row>
        <Col :span="22">
          <Form-item label="学生信息">
            <label>{{ companionPracticingParam.uid }}  - {{ companionPracticingParam.mobile }} - {{ companionPracticingParam.nickname }}</label>
          </Form-item>
        </Col>
        <Col :span="12">
          <Form-item label="开始Level" prop="levelId">
            <Select filterable v-model.number="companionPracticingParam.levelId" @on-change="changeLevel" transfer>
              <Option v-for="item in bookMaterialLevelList"
               :value="item.id" :key="item.id">{{ item.title }}(版本{{item.materialVersion}})</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="10">
          <Form-item label="教室" prop="schoolId" >
            <Select v-model.number="companionPracticingParam.schoolId" transfer>
              <Option v-for="item in $constant.schoolEnums"
                :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="开始课程" prop="lessonId">
            <Select v-model.number="companionPracticingParam.lessonId" transfer>
              <Option v-for="item in bookMaterialLessonsList"
                :value="item.id" :key="item.id">{{ item.title }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="开始时间" prop="lsnBeginDayTime">
            <Row :gutter="6">
              <Col span="7">
                <Form-item >
                  <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                    @on-change="lsnBeginTimeDateChange" :clearable="false"
                    v-model="companionPracticingParam.lsnBeginTimeDate"></Date-picker>
                </Form-item>
              </Col>
              <Col span="5">
                <Form-item >
                  <Time-picker @on-change="onChangeTime" :clearable="false" :value="timeStr"
                    format="HH:mm" :steps="[1, 30]" placeholder="时间" v-model="companionPracticingParam.beginTime"></Time-picker>
                </Form-item>
              </Col>
              <Col span="4">
                  <Form-item>
                    <Select v-model.number="companionPracticingParam.timeLength"
                      @on-change="clearTchList" transfer>
                      <Option v-for="item in timeLengthList"
                        :value="item.code" :key="item.code">{{ item.text }}</Option>
                    </Select>
                  </Form-item>
              </Col>
              <Col span="5" offset="1">
                <Button type="info" @click="searchTch" :loading="loadingSearch">搜索</Button>
              </Col>
            </Row>
          </Form-item>
        <Form-item prop="category">
          <RadioGroup v-model="companionPracticingParam.category">
            <Radio label="1">
              <span>全职老师</span>
            </Radio>
            <Radio label="2">
              <span>兼职老师</span>
            </Radio>
          </RadioGroup>
        </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="空课老师">
            <TeacherSelect :category="[1,2,3]" v-model="tId"  :label="tchName" @on-change="onTchChange"></TeacherSelect>
          </Form-item>
          <Form-item prop="tchId">
            <Row >
              <Radio-group v-model.number="companionPracticingParam.tchId">
                <Row>
                  <Col v-for="item in tchList" style="width: 140px;" :span="10">
                    <Radio :key="item.id" :label="item.id">{{ item.id }} - {{ item.firstName }} {{ item.lastName }}</Radio>
                    <a @click="showTchMessage(item.id)"><img :src="tchAvatarSrc(item.avatar)" style="width: 120px;height: 120px"></a>
                  </Col>
                </Row>
              </Radio-group>
            </Row>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingConfirm" @click="insertChineseLesson" >确定</Button>
    </div>
  </Modal>
  <tch-info-modal class="tch-info-modal" :canEdit="false"  :value="showTchInfoModal" @on-close="showTchInfoModal=false" :tchId="tchId" :successCallback="updateTchInfoSuccess"></tch-info-modal>
</div>
</template>
<script>
  import TchInfoModal from '../teacher/modal/TchInfoModal'
  import commonUtils from '@/tools/commonUtils.js'
  export default {
    components: {
      TchInfoModal
    },
    name: 'UserPLLessonModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      user: {
        type: Object
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      let self = this
      return {
        visible: this.value,
        loadingConfirm: false,
        loadingSearch: false,
        classTypeList: [{ code: 1, text: 'ClassIn' }],
        timeLengthList: [{ code: 25, text: '25' }],
        bookMaterialLevelList: null,
        bookMaterialLessonsList: null,
        tchList: [],
        tId: '',
        tchName: '',
        companionPracticingParam: {
          uid: null,
          tchId: '',
          category: '',
          classType: 1,
          courseType: 8,
          lsnBeginTimeDate: null,
          lsnBeginTime: null,
          lsnBeginDayTime: null,
          timeLength: 25,
          beginTime: '18:00',
          schoolId: 0,
        },
        timeStr: '18:00',
        chineseLessonRule: {
          levelId: [
            { type: 'integer', required: true, message: '请选择开始Level', trigger: 'change' }
          ],
          lessonId: [
            { type: 'integer', required: true, message: '请选择开始课程', trigger: 'change' }
          ],
          classType: [
            { type: 'integer', required: true, message: '请选择教室', trigger: 'change' }
          ],
          tchId: [
            { type: 'integer', required: true, message: '请搜索并选择老师', trigger: 'change' }
          ],
          lsnBeginDayTime: [
            { type: 'integer', required: true, message: '请选择日期', trigger: 'change' },
            { validator (rule, value, callback, source, options) {
              let errors = []
              if (self.companionPracticingParam.time === '') {
                errors.push('请选择时间')
                callback(errors)
                return
              }
              let lsnBeginTime = self.getLsnBeginTime()
              let nowTime = new Date().getTime() / 1000
              if (lsnBeginTime !== '' && nowTime >= lsnBeginTime) {
                errors.push('开始时间应在当前时间之后')
                callback(errors)
                return
              }
              callback()
            } }
          ]
        },
        tchId: null,
        showTchInfoModal: false
      }
    },
    methods: {
      tchAvatarSrc (avatar) {
        return commonUtils.getTotalUrl(avatar) || 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg'
      },
      insertChineseLesson () {
        let self = this
        self.$http.get('/bookLesson/selectTchOpendCount?tchId=' + self.companionPracticingParam.tchId + '&courseType=' + self.companionPracticingParam.courseType).then(function (res) {
          if (res && res.data >= 120) {
            self.$Modal.confirm({
              title: '提示',
              content: '选择的陪练老师单月已超过120课，当前老师本月已上课' + res.data + '节，上课费用增加，是否继续预约此老师课程！',
              width: 300,
              okText: '确定',
              loading: true,
              onOk: () => {
                self.insertLesson()
                self.$Modal.remove()
              }
            })
          } else {
            self.insertLesson()
          }
        })
      },
      insertLesson () {
        let self = this
        self.loadingConfirm = true
        self.$refs.chineseLessonForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingConfirm = false
            return
          }
          self.companionPracticingParam.lsnBeginTime = self.getLsnBeginTime()
          self.$http.post('/user/lesson/addCourse', self.companionPracticingParam).then(function (res) {
            self.loadingConfirm = false
            if (res) {
              self.$Message.success('约课成功!')
              self.visible = false
              return
            }
          })
        })
      },
      searchTch () {
        let self = this
        let isNotError = true
        self.$refs.chineseLessonForm.validateField('lsnBeginDayTime', (valid) => {
          if (valid !== '') isNotError = false
        })
        if (!isNotError) return
        self.loadingSearch = true
        self.tchList = []
        let path = '/tch/time/queryFreeTimeTch?lsnBeginTime=' + self.getLsnBeginTime() +
          '&timeLength=' + self.companionPracticingParam.timeLength + '&tchType=3'
        if (self.tId) {
          path = path + '&tchId=' + self.tId
        }
        if (self.companionPracticingParam.category) {
          path = path + '&category=' + self.companionPracticingParam.category
        }
        self.$http.post(path).then(function (res) {
          if (res && res.data) {
            self.tchList = res.data
          }
          self.loadingSearch = false
        })
      },
      onChangeTime (val) {
        this.companionPracticingParam.time = val && parseInt(this.$dateUtil.getSecondByHm(val))
      },
      lsnBeginTimeDateChange (value) {
        this.companionPracticingParam.lsnBeginDayTime = value && parseInt(this.$moment(value, 'YYYY-M-D').format('X'))
      },
      loadBookMaterialLevel () {
        let self = this
        if (self.bookMaterialLevelList) {
          return
        }
        self.$http.get('/bookMaterialLevel/listByCondition?status=1&ptype=2').then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.bookMaterialLevelList = res.data
        })
      },
      changeLevel (val) {
        if (!val) {
          return
        } else {
          let self = this
          self.bookMaterialLessonsList = null
          self.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + val).then(function (res) {
            if (!res || !res.data) {
              return
            }
            self.bookMaterialLessonsList = res.data
          })
        }
      },
      getLsnBeginTime () {
        return parseInt(this.companionPracticingParam.lsnBeginDayTime) + ((this.companionPracticingParam.beginTime).getMinutes()) * 60 +
          ((this.companionPracticingParam.beginTime).getHours()) * 60 * 60
      },
      clearTchList () {
        this.tchList = []
        this.companionPracticingParam.tchId = ''
      },
      showTchMessage (id) {
        this.tchId = parseInt(id)
        this.showTchInfoModal = true
      },
      updateTchInfoSuccess () {
        this.showTchInfoModal = false
      },
      onTchChange (id, name) {
        this.tchName = name
        if (id) {
          this.searchTch()
        }
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === true) {
          this.loadingConfirm = false
          this.loadBookMaterialLevel()
          this.clearTchList()
          this.$refs['chineseLessonForm'].resetFields()
          this.companionPracticingParam.uid = this.user.id
          this.companionPracticingParam.nickname = this.user.nickname
          this.companionPracticingParam.mobile = this.user.mobile

          let now = new Date()
          now = new Date(now.getFullYear(), now.getMonth(), now.getDate())
          this.companionPracticingParam.lsnBeginTimeDate = now
          this.companionPracticingParam.lsnBeginDayTime = now.getTime() / 1000
          this.timeStr = '18:00'
          this.companionPracticingParam.time = 18 * 3600
        } else {
          this.tId = ''
          this.tchName = ''
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UserPLLessonModal.vue?5fce6114